// extracted by mini-css-extract-plugin
export default {"anonymousAvatar":"boIOTX","withBorder":"Ga1vkl","filter":"lqWiYu"};